import {
  checkNativeTrackingPermissions,
  isNativeTrackingAvailable
} from '@/services/nativeTracking';

export async function checkLocationPermission() {
  if (isNativeTrackingAvailable()) {
    return checkNativeTrackingPermissions();
  }

  if (!navigator.geolocation) {
    return {
      location: false,
      state: 'unavailable'
    };
  }

  if (navigator.permissions?.query) {
    try {
      const permission = await navigator.permissions.query({ name: 'geolocation' });
      return {
        location: permission.state === 'granted',
        state: permission.state
      };
    } catch (error) {
      // Alguns navegadores expõem a API Permissions, mas não aceitam geolocation.
    }
  }

  return {
    location: false,
    state: 'unknown'
  };
}
